<template>
    <div id="schedule">
        <h3>{{ new Date() | moment("MMMM D, YYYY") }}</h3>
        <!-- <p><a href="https://meet.google.com/lookup/h54m65h2qe?authuser=0&hs=179" target="_blank">Open Google Meet</a></p> -->
        <ul class="uk-list uk-list-striped">
            <li><router-link to="/a202/attendance"><span>8:00 - 8:15</span> Attendance</router-link></li>
            <li><router-link to="/a202/math"><span>8:15 - 9:45</span> Math</router-link></li>
            <li><router-link to="/a202/recess"><span>9:45 - 10:00</span> Recess</router-link></li>
            <li><router-link to="/a202/reading"><span>10:00 - 11:00</span> Reading</router-link></li>
            <li><router-link to="/a202/iready"><span>10:00 - 11:30</span> iReady</router-link></li>
            <li><router-link to="/a202/lunch"><span>11:30 - 12:30</span> Lunch</router-link></li>
            <li><router-link to="/a202/accellus"><span>12:30 - 1:30</span> Accellus</router-link></li>
            <li><router-link to="/a202/temperature-check"><span>1:30 - 2:15</span> Temperature Check</router-link></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Schedule'
}
</script>